import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const buildSearchProductsCacheKey = (searchParams: URLSearchParams): string => {
  const brand = searchParams.get('brand') ?? '';
  const searchTerm = searchParams.get('searchTerm') ?? '';

  return `latest_searched_products:${brand}:${searchTerm}`;
};

const useSearchProductsCacheKey = (): string => {
  const [searchParams] = useSearchParams();

  return useMemo(
    () => buildSearchProductsCacheKey(searchParams),
    [searchParams],
  );
};

export default useSearchProductsCacheKey;
